import React, { useEffect } from 'react';
import { useTokens } from '../hooks/useAuth';
import { apiClient } from '../services/apiClient';

interface ApiAuthProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that connects Auth0 authentication to the API client
 * Sets up both access and ID token providers for API calls when authentication is enabled
 */
export const ApiAuthProvider: React.FC<ApiAuthProviderProps> = ({ children }) => {
  const { getTokens } = useTokens();
  
  useEffect(() => {
    // Set up token providers in the API client
    const getAccessToken = async () => {
      const tokens = await getTokens();
      return tokens.accessToken;
    };
    
    const getIdToken = async () => {
      const tokens = await getTokens();
      return tokens.idToken;
    };
    
    apiClient.setTokenProvider(getAccessToken);
    apiClient.setIdTokenProvider(getIdToken);
    
    // Cleanup on unmount (though this provider typically lives for the app lifetime)
    return () => {
      apiClient.setTokenProvider(undefined);
      apiClient.setIdTokenProvider(undefined);
    };
  }, [getTokens]);

  return <>{children}</>;
};